(function () {
  window.alfaExtensions = window.alfaExtensions || {};

  if (!window.alfaExtensions.remoteLogger) {
    window.alfaExtensions.remoteLogger = {
      sendLog: function (
        message,
        eventName = "alfatours-remote-log",
        severity = "error",
        extraData = {}
      ) {
        const payload = {
          createdAt: Date.now(),
          event_name: eventName,
          message,
          severity,
          token: "d88f8836-d1f2-11ef-9786-42010ac80006",
          extra: {
            stack: new Error().stack,
            ...extraData,
          },
        };

        fetch("https://logs.ncscale.io/v1/logs", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then((response) => {
            if (!response.ok) {
              console.error(
                "Failed to send log to remote:",
                response.statusText
              );
            }
          })
          .catch((error) => {
            console.error("Error while sending log to remote:", error);
          });

        console.log(`[${severity.toUpperCase()}] Log sent to remote:`, message);
      },
    };

    document.dispatchEvent(new Event("alfaRemoteLoggerReady"));
  }
})();
